module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/crm_icon-9ee486696eee2082344e72d36371abe4.png";